import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import InitSettings from './InitSettings';
import { store } from './store';
import { ModalProvider } from './components/Modal/ModalContext';

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <ModalProvider>
                    <InitSettings />
                </ModalProvider>
            </Provider>
        </React.StrictMode>,
    );
}
